import { IAddOnsState, defaultAddOnsModel } from '../../classes/add-ons';
import { IAddOnProduction } from '../../custom/classes/production';

import { ActionType, IAddOnsStateAction } from '../../classes/add-on-actions';

import * as moment from 'moment';
import { filterMap } from '../../../package-listing/helpers/map-helpers';

/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export default function addonsReducer(state: IAddOnsState = defaultAddOnsModel, action: IAddOnsStateAction) {
    switch (action.type) {
       
        case ActionType.LoadProductions: {
            return { ...state, addOnProductions: action.value } as IAddOnsState;
        }
        case ActionType.RecievePerformanceDetails: {
            var perfDetail = action.value;
            var updatedState = state.addOnProductions.map(prod => {
                var updatedPerformances = prod.performances.map(perf => {
                    if (perf.id == perfDetail.performanceId) {
                        var newObj = Object.assign({}, perf, { performancePricing: perfDetail.pricing , unavailable: false});
                        return newObj;
                    }
                    return perf;
                });
                return Object.assign({}, prod, { performances: updatedPerformances, loadedFromApi: true });;
            });
            return { ...state, addOnProductions: updatedState, errorMessages: [] } as IAddOnsState;
        }
        case ActionType.PerformanceUnAvailable: {
            var perfId = action.value;
            var newUpdatedState = state.addOnProductions.map(prod => {
                var updatedPerformances = prod.performances.map(perf => {
                    if (perf.id == perfId) {
                        var newObj = Object.assign({}, perf, { unavailable: true, loadedFromApi: true });
                        return newObj;
                    }
                    return perf;
                });
                return Object.assign({}, prod, { performances: updatedPerformances });;
            });
            return { ...state, addOnProductions: newUpdatedState, errorMessages: [] } as IAddOnsState;
        }
        case ActionType.FailedReserve: {
            var failedPerfs = action.value;
            return { ...state, failedReserve: failedPerfs, errorMessages: [] } as IAddOnsState;
        }
        case ActionType.DisplayLoading: {
            var enable = action.value;
            return { ...state, processing: enable, errorMessages: [] } as IAddOnsState;
        }
        case ActionType.AddPerformanceToRequest: {
            var selectedPerfId = action.value as number;
            var currentPerfRequests = state.reserveRequests;
            currentPerfRequests.push({ performanceId: selectedPerfId, priceTypeQuantity: new Map<number, number>(), zoneId: 0, priceType: 0, quantity: 0, total: 0 })
            return { ...state, reserveRequests: currentPerfRequests, errorMessages: [] } as IAddOnsState;
        }
        case ActionType.RemoveAllPerformanceFromRequest: {
            return { ...state, reserveRequests: [], errorMessages: [] } as IAddOnsState;
        }
        case ActionType.RemovePerformanceFromRequest: {
            var selectedPerfId = action.value as number;
            console.log(state.reserveRequests);
            var currentPerfRequests = state.reserveRequests.filter(req => { return req.performanceId != selectedPerfId });
            console.log( currentPerfRequests);
            return { ...state, reserveRequests: currentPerfRequests, errorMessages: [] } as IAddOnsState;
        }

        case ActionType.UpdatePriceTypeToRequest: {
            var selectedValue = action.value;
            var currentPerfRequests = state.reserveRequests.map(req => {
                if (req.performanceId == selectedValue.performanceId) {
                    req.priceTypeQuantity.set(selectedValue.priceTypeId, selectedValue.quantity);
                }
                return req;
            });
            return { ...state, reserveRequests: currentPerfRequests, errorMessages: [] } as IAddOnsState;
        }
        case ActionType.UpdateTotal: {
            var selectedValue = action.value;
            var currentPerfRequests = state.reserveRequests.map(req => {
                if (req.performanceId == selectedValue.performanceId) {
                    req.total = selectedValue.total;
                }
                return req;
            });
            return { ...state, reserveRequests: currentPerfRequests, errorMessages: [] } as IAddOnsState;
        }
        case ActionType.UpdateZoneToRequest:{
            var selectedValue = action.value;
            var currentPerfRequests = state.reserveRequests.map(req => {
                if (req.performanceId == selectedValue.performanceId) {
                    req.zoneId = selectedValue.zoneId;
                }
                return req;
            });
            return { ...state, reserveRequests: currentPerfRequests, errorMessages: [] } as IAddOnsState;
        }
        case ActionType.UpdateProductionProcessing: {
            return { ...state, processing: true, errorMessages: [] } as IAddOnsState;
        }
        case ActionType.UpdateProductionProcessingErrors: {
            return { ...state, processing: false, errorMessages: action.value } as IAddOnsState;
        }
        default:
            return state;
    }
}
